import styled from 'styled-components';

export const Background = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const RootCalcContainer = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

export const RootCalcBody = styled.div`
  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;

    a {
      color: var(--primary-40, #3baab0);
      text-decoration: none;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.28px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
